import { render, staticRenderFns } from "./veJkyProjectPlan.vue?vue&type=template&id=2aa8d500&scoped=true"
import script from "./veJkyProjectPlan.vue?vue&type=script&lang=js"
export * from "./veJkyProjectPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8d500",
  null
  
)

export default component.exports